import React from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

import './Button.scss';

interface ButtonProps {
  /** ClassName Used by button */
  className?: string,
  /** Link the button should follow, if button has a link onClick function will not be executed */
  link?: string,
  /**  */
  disabled?: boolean,
  /** size of the button*/
  size?: 'big' | 'medium' | 'small' | 'extra-small',
  type?: 'button' | 'submit' | 'reset',
  style?: {},
  children?: {} | [],
  /** Text of Button*/
  text?: string,
  /** On Click funtion will be executed only when Button don't have a link prop*/
  onClick?: (e: any) => void, // eslint-disable-line
  /** Can be usefull when calling some functions */
  name?: string,
  value?: string,
  tabIndex?: number
}

export default function Button({
  className,
  text,
  link,
  disabled=false,
  onClick,
  size='medium',
  type='button',
  children,
  style,
  name,
  tabIndex=0
}: ButtonProps) {
  const history = useHistory();

  const buttonLink = (link: string) => (e) => {
    e.preventDefault();
    history.push(link);
  };

  return (
    <button
      className={
        classNames('btn', className, {
          [`${ className }--disabled`]: disabled,
          [`btn--${ size }`]: true
        })
      }
      type={ type }
      onClick={ link ? buttonLink(link) : onClick }
      disabled={ disabled }
      name={ name }
      tabIndex={ tabIndex }
      style={ style }
    >
      { children || text }
    </button>
  );
}
